/**
 * プランの条件編集
 *
 * 常設シートの中身として差し替えて使う。条件を変えても自動では最適化しない。
 * 課金が絡むので実行は明示操作に限る。
 */

import { useState } from 'react'

import type { RoutePlanItem } from '@/api/types/route-plan'
import { Button } from '@/components/ui/button'
import { useSubmitLock } from '@/hooks/useSubmitLock'

import { PlanConditionFields } from '../../components/plan-condition-fields'
import type { PlanCondition } from '../../lib'
import { isConditionReady } from '../../lib'

type Props = {
  initial: PlanCondition
  /** 出発地・到着地に充てられるプラン内のスポット */
  spots: RoutePlanItem[]
  onSubmit: (condition: PlanCondition) => Promise<void>
}

/** 閉じるとアンマウントされるので、開くたびに入力は初期値へ戻る */
export const PlanConditionPanel = ({ initial, spots, onSubmit }: Props) => {
  const [condition, setCondition] = useState(initial)
  const { isSubmitting, run } = useSubmitLock()

  const handleSubmit = async () => {
    await run(() => onSubmit(condition))
  }

  return (
    <div className="space-y-4 px-4 pt-4 pb-6">
      <PlanConditionFields value={condition} onChange={setCondition} spots={spots} />
      <p className="text-xs text-muted-foreground">
        保存しただけでは順番は変わりません。再最適化は詳細画面から実行してください
      </p>
      <Button
        className="w-full"
        disabled={!isConditionReady(condition) || isSubmitting}
        onClick={() => void handleSubmit()}
      >
        保存
      </Button>
    </div>
  )
}
